import { IOfferModeWithFSecure } from "@nju/data-access-portal-offers";
import { Icon } from "@nju/icons";
import { IScope } from "@nju/scope";
import { Text } from "@nju/ui";
import { ChangePaymentButton } from "../../ChangePaymentButton";
import { ChangePaymentPendingInfo } from "../../ChangePaymentPendingInfo";

interface ICreditCardProps {
  maskedCardNumber: string;
  isPending: boolean;
  showChangePaymentButton: boolean;
  openModal: () => void;
  mode: IOfferModeWithFSecure;
  variant: IScope;
  userId: string | undefined;
}

export function CreditCard({
  maskedCardNumber,
  isPending,
  showChangePaymentButton,
  openModal,
  mode,
  variant,
  userId,
}: ICreditCardProps) {
  return (
    <div className="items-start flex">
      <div className="pr-3 shrink-0">
        <Icon height={28} name="credit-card" tone="accent" width={28} />
      </div>
      <div className="justify-center flex-1 flex flex-col gap-1">
        <Text weight="bold">
          karta płatnicza **** **** ****&nbsp;
          {maskedCardNumber}
        </Text>
        {variant === "portal" && isPending && (
          <ChangePaymentPendingInfo tone="accent" />
        )}
        {variant === "portal" && showChangePaymentButton && (
          <ChangePaymentButton
            isPending={isPending}
            mode={mode}
            openModal={openModal}
            tone="neutral"
            userId={userId}
          />
        )}
      </div>
    </div>
  );
}
